import React, { ReactNode } from 'react';
import Search from 'src/components/Search/Search';
import './GenericSearchBar.scss';

interface GenericSearchBarProps {
  onSearch: (e: any) => void;
  placeholder: string;
  disabled?: boolean;
  stackVertically?: boolean;
  children?: ReactNode;
}

const GenericSearchBar = ({
  onSearch,
  placeholder,
  disabled,
  stackVertically,
  children,
}: GenericSearchBarProps) => {
  const headerClassName: string = stackVertically
    ? 'generic-search-header generic-search-header--stacked'
    : 'generic-search-header';

  return (
    <div className={headerClassName}>
      <div className="generic-search">
        <Search
          size="small"
          placeholder={placeholder}
          onChange={onSearch}
          disabled={disabled}
          theme={undefined}
        />
      </div>
      {children}
    </div>
  );
};

export default GenericSearchBar;
